export default {
    // Vue plugins are automatically passed Vue as the first arg by Vue.use()
    install (Vue, options) {
        // Add instance to vm.
        Vue.prototype.$webAnalytics = options.webAnalytics;

        Vue.directive('track', {
            bind (el, binding, vNode, oldVnode) {
                el.addEventListener('click', () => {
                    // throw an error if first two required values are NOT specified
                    if (!binding.value[0] || !binding.value[1]) {
                        // TODO: link this to directive section in the docs
                        console.warn('WebAnalyticsTrackDirective: no event data, use v-track="[eventName, eventDataObj]"');
                        return;
                    }
                    try {
                        options.webAnalytics.track(...binding.value);
                    }
                    catch (err) {
                        console.warn(`AnalyticsTrackingDirective error: ${err}`);
                    }
                });
            },
        });
    },
};


